import componentStyles from './alert-flag.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {html} from "lit";

export default class AlertFlag extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      background: { type: String },
    };
  }

  render() {
    return html`
      <div class="bg bg-${this.background}">
        <slot name="icon"></slot>
        <slot name="text"></slot>
      </div>
    `;
  }
}

customElements.define('hf-alert-flag', AlertFlag);
